const getInitialState = () => ({
  streak: {
    moves: 0,
    winMoves: 0,
    showPrompt: false,
    status: 'neutral',
    last_action: null,
    spot_id: -1,
  }, // neutral loss win
})
const state = getInitialState()

const getters = {
  streak: state => state.streak,
}

const actions = {
  streak_set({ state, commit, dispatch, getters }, { correctness_group }) {
    let res = null
    const {streak} = state
    let status = correctness_group.streak_status
    status = status === 'neutral' ? streak.status : status
    const moves = status === streak.status ? streak.moves + 1 : 1

    let {winMoves} = streak
    let {showPrompt} = streak
    if (status === 'win') {
      winMoves += 1
      showPrompt = winMoves === 5 ? true : !(winMoves % 10)
    } else {
      winMoves = 0
      showPrompt = false
    }

    res = {
      moves,
      status,
      winMoves,
      showPrompt,
    }
    commit('streak_set', {
      key: 'streak',
      value: res,
    })
  },
  streak_reset({ commit }) {
    commit('streak_reset')
  },
}
const mutations = {
  streak_reset(state, initialState = getInitialState()) {
    Object.assign(state, initialState)
  },
  streak_set(state, { key, value }) {
    state[key] = value
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
